import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import "../../assets/css/signup.css";
import { useNavigate } from "react-router-dom";
import API_URL from "../../localhost/config"; //Importa la variable global
import "@fortawesome/fontawesome-free/css/all.css";

//Toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notifySuccess = (mensaje) => {
  toast.success(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const notifyWanr = (mensaje) => {
  toast.warn(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

function SignUp() {
  const [isSignIn, setIsSignIn] = useState(true);

  const navigate = useNavigate();

  const handleSubmitLogin = (e) => {
    e.preventDefault();
  };

  // LOGIN
  const [usernameLogin, setUsernameLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");

  async function handleLogin() {
    try {
      const response = await axios.post(`${API_URL}/login`, {
        username: usernameLogin,
        password: passwordLogin,
      });

      if (response && response.data) {
        const id = response.data.id;
        localStorage.setItem("userId", id); //Guardo en el localstorage
        localStorage.setItem("token", JSON.stringify(response.data.token));
        navigate("/"); //Me lleva a Welcome
      } else {
        console.error(
          "La respuesta no tiene la estructura esperada:",
          response
        );
        notifyWanr("Usuario o contraseña incorrecta.");
      }
    } catch (error) {
      notifyWanr(error.response?.data?.message);
      console.error(
        "Error al iniciar sesión:",
        error.response?.data?.message || error.message
      );
    }
  }

  // Variables
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Errores de variables
  const [usernameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [usernameTouched, setUsernameTouched] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);

  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      username === "" ||
      email === "" ||
      password === "" ||
      confirmPassword === ""
    ) {
      setError("Por favor, complete todos los campos antes de continuar.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Por favor, verifique no tener errores en el formulario.");
      return;
    }

    handleRegister();
  };

  // Maneja cambios en los campos del formulario
  const handlePasswordChange = (value) => {
    setPassword(value);
    if (confirmPassword) {
      validatePassword(value, confirmPassword);
    }
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
    if (password) {
      validatePassword(password, value);
      if (password === value) {
        setConfirmPasswordError("");
      }
    }
  };

  const handleEmailChange = async (e) => {
    setEmail(e.target.value);
    if (emailTouched && e.target.value === "") {
      setEmailError("");
    }
  };

  const handleEmailBlur = async () => {
    setEmailTouched(true);
    if (email === "") return;
    if (email.trim() !== email) {
      setEmailError(
        "El email no puede contener espacios al principio o al final"
      );
      return;
    }
    await checkEmailAvailability(email);
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    if (usernameTouched && e.target.value === "") {
      setUsernameError("");
    }
  };

  const handleUsernameBlur = async () => {
    setUsernameTouched(true);
    if (username === "") return;
    if (username.includes(" ")) {
      setUsernameError("El nombre de usuario no puede contener espacios");
      return;
    }
    await checkUsernameAvailability(username);
  };

  // Chequeos auxiliares
  // Función para verificar disponibilidad de email
  const checkEmailAvailability = async (email) => {
    try {
      const response = await axios.get(
        `${API_URL}/checkEmailExists?email=${email}`
      );
      const isEmailAvailable = response.data.emailExists;
      if (!isEmailAvailable) {
        setEmailError("El email ya ha sido utilizado");
      } else {
        setEmailError("");
      }
    } catch (error) {
      console.error(
        "Error al realizar el chequeo del usuario:",
        error.response?.data?.message || error.message
      );
      throw error;
    }
  };

  // Función para verificar disponibilidad de username
  const checkUsernameAvailability = async (username) => {
    try {
      const response = await axios.get(
        `${API_URL}/checkUsernameExists?username=${username}`
      );
      const isUsernameAvailable = response.data.usernameExists;
      if (!isUsernameAvailable) {
        setUsernameError("El usuario ya ha sido utilizado");
      } else {
        setUsernameError("");
      }
    } catch (error) {
      console.error(
        "Error al realizar el chequeo del usuario:",
        error.response?.data?.message || error.message
      );
      throw error;
    }
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[aeiou]).{8,}$/;
    if (!regex.test(password)) {
      setPasswordError(
        "La contraseña debe tener al menos 8 caracteres, un número, un signo especial y una vocal"
      );
    } else {
      setPasswordError("");
    }
  };

  const validateConfirmPassword = (password, confirmPassword) => {
    const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[aeiou]).{8,}$/;
    if (password !== confirmPassword) {
      setConfirmPasswordError("Las contraseñas no coinciden");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleRegister = async () => {
    try {
      const response = await axios.post(`${API_URL}/register`, {
        username,
        password,
        email,
      });

      if (response && response.data) {
        const id = response.data.user.id;
        const token = response.data.token;
        localStorage.setItem("userId", id);
        localStorage.setItem("token", JSON.stringify(token));
        navigate("/");
      } else {
        console.error(
          "La respuesta no tiene la estructura esperada:",
          response
        );
      }
    } catch (error) {
      console.error("Error al registrar usuario:", error.response.data.message);
    }
  };

  useEffect(() => {
    const sign_in_btn = document.querySelector("#sign-in-btn");
    const sign_up_btn = document.querySelector("#sign-up-btn");
    const container = document.querySelector(".containerSignUp");

    sign_up_btn?.addEventListener("click", () => {
      container.classList.add("sign-up-mode");
    });

    sign_in_btn?.addEventListener("click", () => {
      container.classList.remove("sign-up-mode");
    });

    // Cleanup
    return () => {
      sign_up_btn?.removeEventListener("click", () => {
        container.classList.add("sign-up-mode");
      });
      sign_in_btn?.removeEventListener("click", () => {
        container.classList.remove("sign-up-mode");
      });
    };
  }, []);

  const handleToggleForm = () => {
    setIsSignIn(!isSignIn);
  };

  return (
    <div className="containerSignUp">
      <div
        className={`forms-containerSignUp ${isSignIn ? "" : "sign-up-mode"}`}
      >
        <div className="signin-signup">
          <form className="sign-in-form" onSubmit={handleSubmitLogin}>
            <div className="section-title">
              <h3>
                Entrar a tu <span>cuenta</span>
              </h3>
            </div>
            <div class="input-field">
              <i class="fas fa-user"></i>
              <input
                value={usernameLogin}
                onChange={(e) => setUsernameLogin(e.target.value)}
                type="text"
                placeholder="Nombre de usuario o email"
              />
            </div>

            <div class="input-field">
              <i class="fas fa-lock"></i>
              <input
                value={passwordLogin}
                onChange={(e) => setPasswordLogin(e.target.value)}
                type="password"
                placeholder="Contraseña"
              />
            </div>

            <input
              type="submit"
              value="Login"
              onClick={handleLogin}
              class="btnsignup solid"
            />
          </form>

          {/* Formulario de registro de nueva cuenta */}
          <form onSubmit={handleSubmit} className="sign-up-form">
            <div className="section-title">
              <h3>
                Nueva <span>cuenta</span>
              </h3>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Nombre de usuario */}
            <div class="input-field">
              <i class="fas fa-user"></i>
              <input
                value={username}
                onChange={handleUsernameChange}
                onBlur={handleUsernameBlur}
                type="text"
                placeholder="Nombre de usuario"
              />
            </div>
            {usernameError && <p style={{ color: "red" }}>{usernameError}</p>}

            {/* Email */}
            <div class="input-field">
              <i class="fas fa-envelope"></i>
              <input
                value={email}
                onChange={handleEmailChange}
                onBlur={handleEmailBlur}
                type="email"
                placeholder="Email"
              />
            </div>
            {emailError && <p style={{ color: "red" }}>{emailError}</p>}

            {/* Contraseña */}
            <div class="input-field">
              <i class="fas fa-lock"></i>
              <input
                value={password}
                onChange={(e) => handlePasswordChange(e.target.value)}
                onBlur={() => validatePassword(password)}
                type="password"
                placeholder="Contraseña"
              />
            </div>
            {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}

            <div class="input-field">
              <i class="fas fa-lock"></i>
              <input
                value={confirmPassword}
                onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                onBlur={() =>
                  validateConfirmPassword(password, confirmPassword)
                }
                type="password"
                placeholder="Confirmar contraseña"
              />
            </div>
            {confirmPasswordError && (
              <p style={{ color: "red" }}>{confirmPasswordError}</p>
            )}
            <input type="submit" class="btnsignup" value="Registrarme" />
          </form>
        </div>
      </div>

      <div className="panels-containerSignUp">
        <div class="panel left-panel">
          <div class="content">
            <h3>¿No tienes cuenta?</h3>
            <p>¡Haz clic aquí para registrarte!</p>
            <button class="btnsignup transparent" id="sign-up-btn">
              Registrarme
            </button>
          </div>
          <img src="img/log.svg" class="image" alt="" />
        </div>
        <div class="panel right-panel">
          <div class="content">
            <h3>¿Ya tienes cuenta?</h3>
            <p>¡Haz clic aquí para entrar!</p>

            <button class="btnsignup transparent" id="sign-in-btn">
              Login
            </button>
          </div>
          <img src="../assets/img/register.svg" class="image" alt="" />
        </div>
      </div>
    </div>
  );
}

export default SignUp;
